<script setup>
import { inject, ref, onMounted, watch, computed } from 'vue'
// import { useMediaQuery } from '@vueuse/core'
import { useI18n } from 'vue-i18n'

import IndexFilters from './IndexFilters.vue'
import IndexMap from './IndexMap.vue'
import API from '@/js/api'

const api = inject('api')
const { t } = useI18n()
const isLoading = ref(false)
const grid = ref(null)
const data = ref({ index: {}, live: {}, map: {} })
// const isMobile = useMediaQuery('(max-width: 767px)')

const model = ref({})

const getData = async () => {
  const qs = API.getQS(model.value)

  window.history.replaceState(null, {}, qs)
  isLoading.value = true

  try {
    const response = await API.get(api[model.value.view] + qs)

    if (model.value.view == 'map')
      response.locations = response.locations?.filter((e) => e.lat && e.long)

    data.value[model.value.view] = response
  } finally {
    isLoading.value = false
  }
}

onMounted(async () => {
  watch(
    model,
    () => {
      // data.value = null
      getData()
    },
    { deep: true }
  )
})
</script>

<template>
  <div class="container">
    <b-loading :is-full-page="true" v-model="isLoading" />
    <!-- <pre>{{ model.value }}</pre> -->

    <IndexFilters v-model="model" />
  </div>

  <template v-if="data">
    <section
      class="section is-medium has-background-grey"
      v-if="model.view == 'index'"
    >
      <div class="container">
        <div
          id="vue-index-grid"
          class="columns is-multiline"
          v-html="data.index?.html"
        ></div>
      </div>
    </section>

    <section
      class="section is-medium has-background-grey"
      v-else-if="model.view == 'live'"
    >
      <div class="container">
        <div id="vue-live-grid" v-html="data.live?.html"></div>
      </div>
    </section>

    <section class="mb-9" v-else-if="data.map.locations && model.view == 'map'">
      <div class="container is-bordered">
        <IndexMap v-bind="{ data: data.map }" />
      </div>
    </section>
  </template>
</template>
